import {initSliderApartment} from "./modules/slider";

initSliderApartment() //переместить вызов этой функции в скрипт получения по ajax списка предложений агента